import React from 'react';
import { oneOfType, arrayOf, node, string } from 'prop-types';

import InfoBoxHeader from './InfoBoxHeader';
import { SCInfoBox } from './styles';

InfoBox.propTypes = {
  children: oneOfType([arrayOf(node), node]).isRequired,
  header: string.isRequired,
  headerType: string,
};

InfoBox.defaultProps = {
  headerType: 'info',
};

function InfoBox({ children, header, headerType }) {
  return (
    <SCInfoBox>
      <div>
        {header && <InfoBoxHeader type={headerType}>{header}</InfoBoxHeader>}
        {children}
      </div>
    </SCInfoBox>
  );
}

export default InfoBox;



// WEBPACK FOOTER //
// ./src/components/InfoBox/InfoBox.js